import api from '../../api';
import models from '../../../models';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

const inputSchema = models.tool.postFindingsToEnrichmentThreadInput;

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'post-findings-to-enrichment-thread',
    {
      title: 'Post Findings to Enrichment Thread',
      description:
        'Post the findings of a local deep-dive investigation back to the Wild Moose enrichment thread in Slack, as a reply to the enrichment message, so the responders following the alert see what the investigation concluded.\n\n' +
        'Background: when an alert fires, Wild Moose runs a playbook and posts an enrichment (the results of its automated investigation) to the alert channel. From there the investigation can be handed off ("teleported") into a local AI assistant session, which fetches that context (fetch-teleport-context tool) and digs deeper with local tools - code, logs, observability. This tool completes that round trip: it sends the conclusions of the local session back to the thread where the alert is being handled.\n\n' +
        'Use this at the end of an investigation session, and only when the user explicitly asked to share the findings - it posts to a shared thread that other responders read, so have the user approve the summary text first.',
      inputSchema,
    },
    async (input) => {
      output.info('Posting investigation findings to the enrichment thread');

      const { permalink } = await api.postFindingsToEnrichmentThread(input);

      return createCallToolResult({
        contentBlocks: [
          createTextContent(
            permalink
              ? `Findings posted successfully: ${permalink}`
              : 'Findings posted successfully'
          ),
        ],
      });
    }
  );
}

export default { setup };
